import Box from "@/components/Box";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import SelectPatientField from "@/tpo/SelectPatient";
import ButtonV2 from "@/v2/Buttons";

import CheckoutPatientDetails from "../../checkout/ui/CheckoutPatientDetails";
import { CMP_PERMISSION_ADMIN } from "../../constants";

export default function SelectPatient({
  selectedPatient,
  onSelect,
  title = "Assign this item to a patient",
  description = "Once you assign this order to a patient, the kit(s) will automatically be registered to them and can’t be changed.",
  titleProps,
  descriptionProps,
  buttonProps,
  selectPatientFieldProps,
  patientDetailsProps,
  onCreate,
  onEdit,
  value,
  setValue,
  canCreate
}) {
  const { organisation, permissions } = useOrganisationContext();
  const patient = organisation?.patients.find(
    p => p.patientProfile.pk === selectedPatient?.patientProfile?.pk
  );

  return (
    <>
      <Box fontFamily="gilroyBold" fontSize={28} {...titleProps}>
        {title}
      </Box>
      <Box fontFamily="gilroyMedium" fontSize={16} {...descriptionProps}>
        {description}
      </Box>
      <SelectPatientField
        patients={organisation?.patients || []}
        value={value}
        onChange={v => {
          setValue(v);
          onSelect(v);
        }}
        {...selectPatientFieldProps}
      />
      {canCreate ? (
        <ButtonV2
          color="green"
          onClick={onCreate}
          withChevron
          size={["sm", "sm", "md"]}
          {...buttonProps}
        >
          create a new patient
        </ButtonV2>
      ) : (
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]} color="midGrey">
          Please contact your team manager if you need to add additional patients
        </Box>
      )}
      {patient && (
        <CheckoutPatientDetails
          patient={patient}
          permissions={permissions}
          onEdit={onEdit}
          buttonProps={buttonProps}
          {...patientDetailsProps}
        />
      )}
    </>
  );
}
